export const ContainerStyle = {
    desktop: `xl:container xl:mx-auto px-10`,
}
